<template>
  <div class="w-[80%]">
    <el-collapse v-model="activeNames">
      <el-collapse-item
        name="1"
        class="border-x"
      >
        <template #title="{ isActive }">
          <div :class="['title-wrapper', { 'is-active': isActive }, 'pl-2', 'border-l', 'text-[#666]']">
            {{ channelSetting.channelType === 'ALL_CHANNELS' ? '所有投放渠道' : showName.join(',') }}
            <el-icon class="header-icon">
              <info-filled />
            </el-icon>
          </div>
        </template>
        <div class="pl-2">
          <el-radio-group
            v-model="channelSetting.channelType"
            :disabled="disabled"
            @change="changeType"
          >
            <div
              v-for="item in channelTypeList"
              :key="item.value"
              class="py-3"
            >
              <el-radio :label="item.value">{{ item.label }}</el-radio>
              <div
                v-if="channelSetting.channelType === 'ALL_CHANNELS' && item.value === 'ALL_CHANNELS'"
                class="p-[20px] pb-0"
              >
                <el-checkbox
                  :label="item.value"
                  v-model="channelSetting[item.value]"
                  v-for="item in channelList"
                  :disabled="disabled"
                  @change="emitMsg"
                  >{{ item.label }}</el-checkbox
                >
              </div>
            </div>
          </el-radio-group>
          <div
            class="ml-[20px]"
            v-if="channelSetting.channelType === 'SELECTED_CHANNELS'"
          >
            <el-tree
              ref="channelTree"
              style="max-width: 600px"
              :data="channelList"
              show-checkbox
              node-key="value"
              :default-expanded-keys="['youtube']"
              :default-checked-keys="defaultKeys"
              :props="{ ...defaultProps, disabled: nodeDisabled }"
              :check-on-click-node="true"
              @check-change="handleTreeCheckChange"
            >
              <template #default="{ node, data }">
                <div class="custom-tree-node">
                  <span>{{ node.label }}</span>
                  <div class="text-[12px] text-[#999] leading-4">
                    {{ data.desc }}
                  </div>
                </div>
              </template>
            </el-tree>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      channelTypeList: [
        {
          label: '所有投放渠道',
          value: 'ALL_CHANNELS',
          desc: '您的广告将在所有符合条件的 Google 渠道中展示，从而提升广告系列效果',
        },
        { label: '指定渠道', value: 'SELECTED_CHANNELS', desc: '您的广告将尽在您选择的符合条件的渠道中展示' },
      ],
      channelListAll: [
        { label: '包括google展示广告网络', value: 'includeDisplay', type: 'ALL_CHANNELS', desc: '' },
        {
          label: 'Google探索',
          value: 'discover',
          type: 'SELECTED_CHANNELS',
          desc: '在 Google 移动平台上的个性化内容信息流中展示的广告',
        },
        {
          label: 'Google展示广告网络',
          value: 'display',
          type: 'SELECTED_CHANNELS',
          desc: '通过 Google 展示广告网络，您可以在第三方网站和应用中投放广告',
        },
        {
          label: 'Gmail',
          value: 'gmail',
          type: 'SELECTED_CHANNELS',
          desc: '在用户的 Gmail 收件箱中展示的广告',
        },
        {
          label: 'Youtube',
          value: 'youtube',
          type: 'SELECTED_CHANNELS',
          desc: '在 YouTube 平台上展示的广告',
          children: [
            {
              label: 'YouTube 插播广告',
              value: 'youtubeInFeed',
              type: 'SELECTED_CHANNELS',
              desc: '在 YouTube 视频播放前、播放期间或播放后展示的广告',
            },
            {
              label: 'YouTube 信息流',
              value: 'youtubeInStream',
              type: 'SELECTED_CHANNELS',
              desc: '在 YouTube 的“接下来观看”动态、首页动态和搜索动态中展示的广告',
            },
            {
              label: 'YouTube Shorts',
              value: 'youtubeShorts',
              type: 'SELECTED_CHANNELS',
              desc: '在 YouTube 的短视频平台上展示的广告告',
            },
          ],
        },
      ],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      channelSetting: {},
      defaultKeys: [],
      activeNames: '',
    };
  },
  computed: {
    channelList() {
      let list = this.channelListAll.filter((v) => v.type === this.channelSetting.channelType);
      if (this.channelSetting.changeType === 'SELECTED_CHANNELS') {
      }
      return list;
    },
    showName() {
      // 1. 获取值为 true 的 key
      const data = this.channelSetting || {};
      const trueKeys = Object.keys(data).filter((key) => data[key] === true);

      // 2. 递归查找 channelListAll 中 value 匹配的 label
      function findLabels(list, keys) {
        let labels = [];
        list.forEach((item) => {
          if (keys.includes(item.value)) {
            labels.push(item.label);
          }
          if (item.children && item.children.length) {
            labels = labels.concat(findLabels(item.children, keys));
          }
        });
        return labels;
      }
      const labels = findLabels(this.channelListAll, trueKeys);
      return labels;
    },
  },
  watch: {
    value: {
      handler() {
        let checkList = [];
        for (let key in this.value) {
          if (this.value[key] === true) {
            checkList.push(key);
          }
        }
        this.channelSetting = { ...this.value };
        console.log(this.value);
        this.defaultKeys = checkList;
        this.$nextTick(() => {
          if (this.$refs.channelTree && typeof this.$refs.channelTree.setCheckedKeys === 'function') {
            this.$refs.channelTree.setCheckedKeys(this.defaultKeys);
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    nodeDisabled(node) {
      // 全局禁用
      if (this.disabled) return true;
      // 可扩展：如有节点级别禁用逻辑可在此补充
      return !!node.disabled;
    },
    // 选择渠道类型
    changeType(type) {
      // 重置所有节点的 disabled 字段
      const resetDisabled = (nodes) => {
        nodes.forEach((node) => {
          this.$set(node, 'disabled', false);
          if (node.children) resetDisabled(node.children);
        });
      };
      resetDisabled(this.channelList);
      if (type === 'SELECTED_CHANNELS') {
        this.defaultKeys = this.channelList.map((v) => v.value);
        console.log(this.defaultKeys);
        if (this.$refs.channelTree && typeof this.$refs.channelTree.setCheckedKeys === 'function') {
          this.$refs.channelTree.setCheckedKeys(this.defaultKeys);
        }
      } else {
        this.$set(this.channelSetting, 'includeDisplay', false);
      }
      //   this.emitMsg();
    },
    // el-tree 最少选择一个
    handleTreeCheckChange() {
      if (!this.$refs.channelTree) return;
      const checkedKeys = this.$refs.channelTree.getCheckedKeys();
      this.defaultKeys = [...checkedKeys];
      const checkedCount = checkedKeys.length;
      // 递归设置 disabled
      const setDisabled = (nodes) => {
        nodes.forEach((node) => {
          if (checkedCount === 1) {
            this.$set(node, 'disabled', checkedKeys.includes(node.value));
          } else {
            this.$set(node, 'disabled', false);
            if (
              !checkedKeys.includes('gmail') &&
              !checkedKeys.includes('display') &&
              !checkedKeys.includes('discover')
            ) {
              if (node.value === 'youtube') {
                this.$set(node, 'disabled', true);
              }
            }
          }
          if (node.children) setDisabled(node.children);
        });
      };
      setDisabled(this.channelList);
      this.$forceUpdate();
      this.emitMsg();
    },
    setValueData(list) {
      let obj = {};
      list.map((v) => {
        console.log(v);
        obj[v] = true;
      });
      return obj;
    },
    emitMsg() {
      let data = {
        includeDisplay: false,
        discover: false,
        display: false,
        gmail: false,
        youtube: false,
        youtubeInFeed: false,
        youtubeInStream: false,
        youtubeShorts: false,
      };
      let emitData = {};
      if (this.channelSetting.channelType === 'ALL_CHANNELS') {
        emitData = {
          ...data,
          channelType: this.channelSetting.channelType,
          includeDisplay: this.channelSetting.includeDisplay,
        };
      } else {
        let checkList = [];
        if (this.$refs.channelTree && typeof this.$refs.channelTree.getCheckedKeys === 'function') {
          checkList = this.$refs.channelTree.getCheckedKeys();
        }
        emitData = { ...data, ...this.setValueData(checkList), channelType: this.channelSetting.channelType };
      }
      this.$emit('input', emitData);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-tree-node__content {
  height: auto !important;
  align-items: flex-start;
  .el-tree-node__expand-icon {
    display: none;
  }
}
::v-deep .el-collapse-item__header {
  border-right: 1px solid #ebeef5;
}
</style>
